
import Skeleton from 'react-loading-skeleton';

export default function VideosLoader() {
    return (
        <>
            <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2 py-3">
                <Skeleton circle={true} className="" />
                <div className="flex flex-col w-full">
                    <span>
                        <p className="text-slate-50 text-sm font-medium"><Skeleton className="" /></p>
                    </span>
                    <div>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                        <span className="text-gray-400 text-xs mt-1"> </span>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                    </div>
                </div>
            </div>
            <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2 py-3">
                <Skeleton circle={"50%"} className="" />
                <div className="flex flex-col w-full">
                    <span>
                        <p className="text-slate-50 text-sm font-medium"><Skeleton className="" /></p>
                    </span>
                    <div>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                        <span className="text-gray-400 text-xs mt-1"> </span>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                    </div>
                </div>
            </div>
            <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2 py-3">
                <Skeleton circle={true} className="" />
                <div className="flex flex-col w-full">
                    <span>
                        <p className="text-slate-50 text-sm font-medium"><Skeleton className="" /></p>
                    </span>
                    <div>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                        <span className="text-gray-400 text-xs mt-1"> </span>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                    </div>
                </div>
            </div>
            <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2 py-3">
                <Skeleton circle={true} className="" />
                <div className="flex flex-col w-full">
                    <span>
                        <p className="text-slate-50 text-sm font-medium"><Skeleton className="" /></p>
                    </span>
                    <div>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                        <span className="text-gray-400 text-xs mt-1"> </span>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                    </div>
                </div>
            </div>
            <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2 py-3">
                <Skeleton circle={true} className="" />
                <div className="flex flex-col w-full">
                    <span>
                        <p className="text-slate-50 text-sm font-medium"><Skeleton className="" /></p>
                    </span>
                    <div>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                        <span className="text-gray-400 text-xs mt-1"> </span>
                        <span className="text-gray-400 text-xs mt-1"><Skeleton className="" /></span>
                    </div>
                </div>
            </div>
        </>
    )
};